import { Edit } from '@/components/admin/edit';
import { SimpleForm } from '@/components/admin/simple-form';
import { TextInput } from '@/components/admin/text-input';

/**
 * **MODIFIER UNE STRUCTURE, C'EST MODIFIER SON NOM INTERNE. RIEN D'AUTRE.**
 *
 * F-56 : « **le compte qui voit tout modifie le nom interne. La structure ne le modifie
 * pas.** » Et c'est le seul champ que la route touche : les colonnes d'affichage ont la leur,
 * les réglages la leur, et **le secret ne se modifie pas** — il se régénère ou se révoque.
 *
 * **Un seul champ dans ce formulaire est donc une règle, pas une ébauche.** Ajouter les
 * colonnes d'affichage ici — elles appartiennent au même rôle — leur donnerait un second
 * chemin d'écriture, ce que Q566 refuse partout ailleurs : « **deux chemins pour un geste font
 * deux autorisations à tenir d'accord, et celle qu'on oublie est la faille.** »
 *
 * **Aucun bouton de suppression**, F-56 (Q543). La peau en pose un par défaut sur un `Edit` ;
 * il n'apparaît pas ici parce que la matrice porte `structures.delete` à `PERSONNE` et que
 * les boutons de la peau consultent `canAccess`. Et si l'un reparaissait, le fournisseur de
 * données lève.
 */
export function EditionDeStructure() {
  return (
    <Edit>
      <SimpleForm>
        <TextInput
          source="nomInterne"
          label="Nom interne"
          helperText="Le seul champ modifiable d’une structure."
        />
      </SimpleForm>
    </Edit>
  );
}
